import React from "react";
import { AppBar, Container, Grid, Paper } from "@mui/material";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';
import Toolbar from '@mui/material/Toolbar';
import configurationService from "../../service/configurationService";
import CustomizedBreadcrumbs from "../../component/breadcrumbs/breadcrumbs";
import SimpleBackdrop from "../../component/loading/loading";
import { Button } from "antd";
import TableConfiguration from "../../component/table-configuration/table-configuration";
import DrawerPrincipal from "../../component/drawer/drawer-principal";
import { usePermissions } from "../../contexts/permissionsContext";


function ListConfiguration(){
    const { getPermission } = usePermissions();
    const permission = getPermission("Configuração");

    const [listConfiguration, setListConfiguration] = useState({
        data: [],
        pagination: {
            currentPage: 1,
            totalPages: 0,
            totalItems: 0,
            itemsPerPage: 10,
            hasNext: false,
            hasPrev: false,
        }
    });

    const [open, setOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        (async () => {
            setOpen(true);

            try {
                const item = await configurationService.list();
                
                if (item && item.success !== false) {
                    // O service agora retorna { success: true, data: [...], pagination: {...} }
                    if (item.data && Array.isArray(item.data) && item.pagination) {
                        setListConfiguration({
                            data: item.data,
                            pagination: item.pagination,
                        });
                    }
                    // Se a API retorna apenas um array (compatibilidade)
                    else if (Array.isArray(item.data)) {
                        console.log("✅ [ListConfiguration] Array encontrado:", item.data.length);
                        setListConfiguration({
                            data: item.data,
                            pagination: item.pagination || {
                                currentPage: 1,
                                totalPages: 1,
                                totalItems: item.data.length,
                                itemsPerPage: 10,
                                hasNext: false,
                                hasPrev: false,
                            }
                        });
                    }
                    else {
                        console.error("❌ [ListConfiguration] Resposta inválida da API:", item);
                        setListConfiguration({
                            data: [],
                            pagination: {
                                currentPage: 1,
                                totalPages: 0,
                                totalItems: 0,
                                itemsPerPage: 10,
                                hasNext: false,
                                hasPrev: false,
                            }
                        });
                    }
                }
                else if (item && item.success === false) {
                    console.error("Erro na API:", item.message);
                    setErrorMessage(item.message);
                    setListConfiguration({
                        data: [],
                        pagination: {
                            currentPage: 1,
                            totalPages: 0,
                            totalItems: 0,
                            itemsPerPage: 10,
                            hasNext: false,
                            hasPrev: false,
                        }
                    });
                }
            } catch (error) {
                console.error("Erro na requisição:", error);
                setListConfiguration({
                    data: [],
                    pagination: {
                        currentPage: 1,
                        totalPages: 0,
                        totalItems: 0,
                        itemsPerPage: 10,
                        hasNext: false,
                        hasPrev: false,
                    }
                });
                setErrorMessage(error.message || "Erro ao carregar configurações");
            } finally {
                setOpen(false);
            }
        })();
    }, []);

    const handleClose = () => {
        setOpen(false);
    };

    const loadPage = async (page, pageSize) => {
        setOpen(true);
        
        try {
            const item = await configurationService.list();
            
            if (item && item.success !== false) {
                // O service retorna { success: true, data: [...], pagination: {...} }
                if (item.data && Array.isArray(item.data) && item.pagination) {
                    setListConfiguration({
                        data: item.data,
                        pagination: item.pagination,
                    });
                }
                // Se a API retorna apenas um array
                else if (Array.isArray(item.data)) {
                    setListConfiguration({
                        data: item.data,
                        pagination: {
                            currentPage: page,
                            totalPages: Math.ceil(item.data.length / pageSize),
                            totalItems: item.data.length,
                            itemsPerPage: pageSize,
                            hasNext: page * pageSize < item.data.length,
                            hasPrev: page > 1,
                        },
                    });
                }
            } else {
                console.error("❌ [ListConfiguration] Erro na API:", item);
                setErrorMessage(item?.message || "Erro ao carregar dados");
            }
        } catch (error) {
            console.error("❌ [ListConfiguration] Erro ao carregar dados:", error);
            setErrorMessage(error.message || "Erro ao carregar dados");
        } finally {
            setOpen(false);
        }
    };

    const handleFilterChange = () => {
        // Filtros podem ser implementados no futuro se necessário
        loadPage(1, listConfiguration.pagination.itemsPerPage || 10);
    };

    const handleSortChange = () => {
        // Ordenação pode ser implementada no futuro se necessário
        loadPage(
            listConfiguration.pagination.currentPage || 1,
            listConfiguration.pagination.itemsPerPage || 10
        );
    };

    return (
        <>
            <Container maxWidth="lx" sx={{ bgcolor: '#EBEBEB', height: '100vh' }}>
                
                <DrawerPrincipal title={"Configuração"} divOpen={
                    <div>
                        <div>
                            <SimpleBackdrop
                                open={open}
                                handleClose={handleClose}
                                title={"Carregando informações..."}
                            />
                            <div className="row mb-3">
                                <CustomizedBreadcrumbs 
                                    title1={"Home"} 
                                    link1={"/"} 
                                    title2={"Lista de Configurações"} 
                                    link2={"#"} 
                                />
                            </div>
                            <Paper sx={{width: '100%', margin: 'auto', overflow: 'hidden' }}>

                                    <AppBar
                                        position="static"
                                        color="default"
                                        elevation={0}
                                        sx={{ borderBottom: '1px solid rgba(0, 0, 0, 0.12)' }}
                                        >
                                        <Toolbar>
                                        <Grid container spacing={2} alignItems="center">
                                                <Grid item>
                                                <h5 style={{ margin: 0, whiteSpace: 'nowrap' }}>Lista de Configurações</h5>
                                                </Grid>
                                                <Grid item xs>
                                                </Grid>
                                                <Grid item>
                                                    {
                                                        permission?.isinsert ? 
                                                        <Link to={"/configuration"}>
                                                            <Button style={{background: 'black', color: '#FFF'}} sx={{ mr: 1 }}>
                                                                <AddIcon /> Novo
                                                            </Button>
                                                        </Link>
                                                        : 
                                                        ""
                                                    }
                                                </Grid>
                                            </Grid>
                                        </Toolbar>
                                    </AppBar>

                                    <div style={{ width: '100%', padding: 10 }}>
                                        {errorMessage && (
                                            <div
                                                style={{
                                                    padding: "10px",
                                                    marginBottom: "10px",
                                                    backgroundColor: "#ffebee",
                                                    color: "#c62828",
                                                    border: "1px solid #ef5350",
                                                    borderRadius: "4px",
                                                }}
                                            >
                                                <strong>Erro:</strong> {errorMessage}
                                            </div>
                                        )}

                                        <TableConfiguration 
                                            data={listConfiguration} 
                                            onPageChange={loadPage}
                                            onFilterChange={handleFilterChange}
                                            onSortChange={handleSortChange}
                                        />
                                    </div>
                            </Paper>
                        </div>
                    </div>
                }/>
            </Container>
        </>
    );
}


export default ListConfiguration;
